import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { HydrotherapyAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-hydrotherapy-slot',
    templateUrl: './hydrotherapy-slot.component.html',
    styleUrl: './hydrotherapy-slot.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class HydrotherapySlotComponent implements SheetSlotComponentBase {

	@Input() action!: HydrotherapyAction;
	value = null;

	constructor() {
	}
}